import { BaseOption } from "entities/common";

export type IncidentSeverity = "medium" | "high";
export type IncidentStatus = "active" | "resolved" | "device_removed";

export type IncidentRecord = {
  id: number;
  asset: string;
  location: string;
  type: string;
  incident: string;
  severity: IncidentSeverity;
  timeDetected: string;
  duration: string;
  timeResolved: string;
  status: IncidentStatus;
};

export const STAT_CARDS: { title: string; value: string; subtitle: string; key: string }[] = [
  { key: "total_active", title: "Total active incidents", value: "21", subtitle: "Open, all severities" },
  { key: "active_high", title: "Active & high priority", value: "19", subtitle: "Open, high" },
  { key: "resolved_last_30d", title: "Resolved", value: "4", subtitle: "Successfully completed in the last month" },
];

export const HEADERS: { label: string; key: string }[] = [
  { label: "Asset", key: "asset" },
  { label: "Location", key: "location" },
  { label: "Type", key: "type" },
  { label: "Incident", key: "incident" },
  { label: "Severity", key: "severity" },
  { label: "Time detected", key: "timeDetected" },
  { label: "Duration", key: "duration" },
  { label: "Time resolved", key: "timeResolved" },
  { label: "Status", key: "status" },
];

export const ASSET_OPTIONS: BaseOption[] = [
  { value: "", label: "All assets" },
  { value: "villa-12", label: "Villa 12" },
  { value: "classroom-3b", label: "Classroom 3B" },
  { value: "conference-room-a", label: "Conference Room A" },
  { value: "main-lobby", label: "Main Lobby" },
];

export const TYPE_OPTIONS: BaseOption[] = [
  { value: "", label: "All types" },
  { value: "Air Quality - CO₂", label: "Air Quality - CO₂" },
  { value: "Air Quality - HCHO", label: "Air Quality - HCHO" },
  { value: "Air Quality - TVOC", label: "Air Quality - TVOC" },
  { value: "Air Quality - PM2.5", label: "Air Quality - PM2.5" },
  { value: "Air Quality - PM10", label: "Air Quality - PM10" },
  { value: "Thermal Comfort - Temperature", label: "Thermal Comfort - Temperature" },
  { value: "Thermal Comfort - Humidity", label: "Thermal Comfort - Humidity" },
];

export const SEVERITY_OPTIONS: BaseOption[] = [
  { value: "", label: "All severities" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];

export const STATUS_OPTIONS: BaseOption[] = [
  { value: "", label: "All statuses" },
  { value: "active", label: "Active" },
  { value: "resolved", label: "Resolved" },
];

export const SEVERITY_LABELS: Record<IncidentSeverity, string> = {
  medium: "Medium",
  high: "High",
};

export const STATUS_LABELS: Record<IncidentStatus, string> = {
  active: "Active",
  resolved: "Resolved",
  device_removed: "Device removed",
};

const ROW_TEMPLATE: { severity: IncidentSeverity; status: IncidentStatus; duration: string }[] = [
  { severity: "medium", status: "resolved", duration: "3h 20m" },
  { severity: "high", status: "active", duration: "-" },
];

export const INCIDENTS: IncidentRecord[] = Array.from({ length: 8 }, (_, index) => {
  const template = ROW_TEMPLATE[index % ROW_TEMPLATE.length];

  return {
    id: index + 1,
    asset: "Villa 12",
    location: "The right corner of the room",
    type: "Air Quality - PM2.5",
    incident: "PM2.5 level has exceeded the threshold immediate ventilation required",
    severity: template.severity,
    timeDetected: "13.04.2026 12:20",
    duration: template.duration,
    timeResolved: "13.04.2026 12:20",
    status: template.status,
  };
});
